"use client"

import Link from "next/link"
import { useTranslations } from "next-intl"

import { cn } from "@/lib/utils"

interface BonusProgramConsentDescriptionProps {
  className?: string
  addressesHref?: string
}

export default function BonusProgramConsentDescription({
  addressesHref,
  className,
}: BonusProgramConsentDescriptionProps) {
  const t = useTranslations("storefront")
  const landingpageHref = t("bonus_program.links.landingpage")
  const termsHref = t("bonus_program.links.terms")
  const linkClassName = "font-semibold text-primary underline hover:text-primary/80"

  return (
    <p className={cn("text-gray-600", className)}>
      {t("account.profile.company.bonus_program.consent_before_bonus_program")}
      <Link
        prefetch={false}
        href={landingpageHref}
        target={"_blank"}
        rel={"noopener noreferrer"}
        className={linkClassName}
      >
        {t("account.profile.company.bonus_program.consent_bonus_program_link")}
      </Link>
      {t("account.profile.company.bonus_program.consent_before_terms")}
      <Link prefetch={false} href={termsHref} target={"_blank"} rel={"noopener noreferrer"} className={linkClassName}>
        {t("account.profile.company.bonus_program.consent_terms_link")}
      </Link>
      {t("account.profile.company.bonus_program.consent_after_terms")}
      <br />
      {t("account.profile.company.bonus_program.info_before_link")}
      <Link
        prefetch={false}
        href={landingpageHref}
        target={"_blank"}
        rel={"noopener noreferrer"}
        className={linkClassName}
      >
        {t("account.profile.company.bonus_program.info_link")}
      </Link>
      {t("account.profile.company.bonus_program.info_after_link")}
      {addressesHref && (
        <>
          <br />
          {t("account.profile.company.bonus_program.missing_company_address")}{" "}
          <Link prefetch={false} href={addressesHref} className={linkClassName}>
            {t("account.profile.company.bonus_program.address_link")}
          </Link>
        </>
      )}
    </p>
  )
}
